export default __webpack_public_path__ + "static/media/coa3.57705bc6.png";